<script lang="ts">
	import { getContext } from 'svelte'
	export let num;
	export let validate: () => boolean;

	const getStepWizardContext = () => {
		const context = getContext('StepWizard')
		if (!context) {
			throw new Error('StepWizard compound components cannot be rendered outside the StepWizard component')
		}
		return context
	}

	const { step, nextStep, goTo, previousStep, numSteps } = getStepWizardContext();

	function goNext() {
		if (validate()) {
			nextStep();
		}
	}

	function goToValidated(step: number) {
		if (validate()) {
			goTo(step);
		}
	}

	$numSteps += 1;
</script>

{#if $step === num}
	<slot current={num} nextStep={goNext} {previousStep} goTo={goToValidated}></slot>
{/if}
